 <template>
  <div class="page">
    <el-form
       v-if='isSearch'
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
          <el-form-item label='店铺名称'>
                <GridSelectShop
                    style='width: 200px'
                    title='选择店铺'
                    labelName='shopName'
                    labelValue='id'
                    :value='queryForm.storeId'
                    :limit='1'
                    size='small'
                    @getValue='getValueShopId'
                    :columns="SHOP_code"
                    :searchs="SHOP_search"
                    dataListUrl='/mall/shop/findList'
                    entityBeanName='mallShop'
                    queryEntityUrl='/mall/shop/get'
                    @storeInformation="storeInformation"
                >
                </GridSelectShop>
            </el-form-item>
   
        <el-form-item label="用户">
          <GridSelectU style="width: 200px" labelName="userName"
                        labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                        @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
          </GridSelectU>
      </el-form-item>
      <el-form-item label="订单编号">
        <el-input v-model="queryForm.orderNumber"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getBrandList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetQueryFrom"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="icon-group">
           <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span> 
          <span
            class="icon-box"
            @click="refreshShopBrandList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table
        height='100%'
        :data="shopBrandList"
        row-key="id"
        @selection-change="handleSelectionChange"
        size="small"
        border
        v-loading="loading"
      >
      <el-table-column
          align="center"
          prop="failReason"
          label="失败原因"
          width="400px"
          style="white-space: normal !important ; "
        >
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="orderId"
          label="用户信息"
          min-width="10%"
        >
          <template slot-scope="scope">
            <div class="store_info">
              <div>
                账号：{{ scope.row.userName || '--' }}
              </div>
              <div>
                昵称：{{ scope.row.userNickname || '--' }}
              </div>
              <div>
                手机号：{{ scope.row.userMobile || '--' }}
              </div>

            </div>
          </template>
        </el-table-column>
             <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="orderId"
          label="店铺信息"
          min-width="10%"
        >
          <template slot-scope="scope">
            <div class="store_info">
               <div>
                  店铺名称：{{ scope.row.storeName || '--' }}
                </div>
                <div>
                  店铺联系人名称：{{ scope.row.contactPerson || '--' }}
                </div>
                <div>
                  店铺联系人手机号：{{ scope.row.contactPhone || '--' }}
                </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="orderNumber"
          label="订单编号"
          min-width="10%"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.orderNumber || '--' }}
            </div>  
            </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
    </div>
     
  </div>
</template>

 <script>
import { Refresh, Search } from '@v2icons/tabler';
import { get, post, deleteFun, upload } from '@/utils/request.js';
import { SHOP, SHOP_SEARCH,USER,USER_SEARCH } from '@/utils/constant';
import GridSelectShop from '@/components/gridselect/gidselect.vue';
import GridSelectU from '@/components/gridselect/index.vue';
export default {
   components: {
    Refresh,
    Search,
    GridSelectShop,
    GridSelectU
  },
    data() {
        return {
            SHOP_code: SHOP,
            SHOP_search: SHOP_SEARCH,
            USER_search: USER_SEARCH,
            USER_code: USER,
            queryForm: {
                orderNumber: '', // 订单编号
                storeId: '', // 店铺ID
                userId: '', // 用户ID

            },
            goodsTitle: '商品列表',
            loading: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            multipleSelection: [],
            shopBrandList: [],//列表数据
            storeInformationVal: {}, // 店铺信息
        };
    },
    created() {
        this.getBrandList();
    },
    methods: {
      // 店铺信息
      storeInformation(val){
            this.storeInformationVal = val;
            
      },
      // 获取店铺信息id
      getValueShopId(value) {
            this.queryForm.storeId = value;
        },
      // 获取用户信息id
      getSearchValueUser(value){
          this.queryForm.userId = value
      },
       
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopBrandList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopBrandList = [];
        },
      
        refreshShopBrandList() {
            this.resetShopBrandList();
            this.getBrandList();
        },
        // 列表数据请求
        getBrandList() {
            this.loading = true;
            get(`/shop/storePayAbnormal/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopBrandList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        // 重置查询条件
        resetQueryFrom() {
            this.queryForm.orderNumber = '';
            this.queryForm.storeId = '';
            this.queryForm.userId = '';
            this.getBrandList();
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetQueryForm() {
            this.queryForm.orderNumber = '';
            this.queryForm.storeId = '';
            this.queryForm.userId = '';
            this.getBrandList();
        },
        
        handleSelectionChange(value) {
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getBrandList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getBrandList();
        },
    }
};
</script>
 
<style lang="scss" scoped>

.store_info{
  text-align: left;
  margin-left: 10%;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.logo-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
</style>